import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from '../i18n';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// Function to detect browser language
const getBrowserLanguage = () => {
  // Check if browser language is available
  if (typeof window === 'undefined' || !navigator.language) {
    return 'en';
  }

  // Get browser language (e.g., 'cs-CZ', 'en-US', 'cs', 'en')
  const browserLang = navigator.language.toLowerCase();
  
  // Check primary language code (first two characters)
  const langCode = browserLang.split('-')[0];
  
  // Map to supported languages
  const supportedLanguages = {
    'cs': 'cs',  // Czech
    'en': 'en'   // English
  };

  // Return detected language or default to English
  return supportedLanguages[langCode] || 'en';
};

// Get initial language: saved preference > browser language > English
const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('eevn-language');
  if (savedLanguage) {
    return savedLanguage;
  }
  return getBrowserLanguage();
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return getInitialLanguage();
  });

  useEffect(() => {
    localStorage.setItem('eevn-language', language);
    i18n.changeLanguage(language);
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

